import { ObservationService } from '../../../shared/observation/observation.service';
import { Subscription } from 'rxjs';
import { WebContentDto } from '../../../web-content/shared/dto/web-content.dto';
import { WebContentService } from '../../../web-content/shared/web-content.service';
import { Component, OnInit, Input, SimpleChanges, OnChanges, OnDestroy } from '@angular/core';
import { WebContentSearchDto } from 'src/app/web-content/shared/dto/web-content-search.dto';

@Component({
  selector: 'wl-profile-view-web-content',
  templateUrl: './profile-view-web-content.component.html',
  styleUrls: ['./profile-view-web-content.component.less'],
    standalone: false
})
export class ProfileViewWebContentComponent implements OnInit, OnChanges, OnDestroy {
  @Input() profileId: number;

  webContentRecords: WebContentDto[];

  private _profileSubscription: Subscription;

  constructor(private _webContentService: WebContentService, private _observationService: ObservationService) {}

  ngOnInit() {
    this._profileSubscription = this._observationService.observeProfiles().subscribe(() => {
      this.loadWebContents();
    });
  }

  ngOnChanges(simpleChanges: SimpleChanges) {
    if (simpleChanges.profileId && this.profileId) {
      this.loadWebContents();
    }
  }

  ngOnDestroy() {
    if (this._profileSubscription) {
      this._profileSubscription.unsubscribe();
    }
  }

  private loadWebContents() {
    if (this.profileId) {
      this._webContentService.search(new WebContentSearchDto(this.profileId, true)).then((searchResult) => {
        this.webContentRecords = searchResult.Result;
      });
    }
  }
}
